module.exports = __webpack_public_path__ + "img/view.47ad89a0.svg";